// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1mcgu","header":"PatientQuestionnaire_header__3cS3J","info":"PatientQuestionnaire_info__JCKcM"};